import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as fromRouter from '@ngrx/router-store';
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Params
} from '@angular/router';
import { STORE_KEYS } from '../shared/utilities/defines';

export interface RouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
}
/** this interface represents all keys and values for all what we have in the store  */
export interface IAppState {
  routerReducer: fromRouter.RouterReducerState<RouterStateUrl>;
}

/** The root reducer */
export const reducers: ActionReducerMap<IAppState> = {
  routerReducer: fromRouter.routerReducer
};

export const getRouterState = createFeatureSelector<
  fromRouter.RouterReducerState<RouterStateUrl>
>(STORE_KEYS.MODULES.ROUTING);

export class CustomSerializer
  implements fromRouter.RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    const { url } = routerState;
    const { queryParams } = routerState.root;

    let state: ActivatedRouteSnapshot = routerState.root;
    while (state.firstChild) {
      state = state.firstChild;
    }
    const { params } = state;

    return { url, queryParams, params };
  }
}
